module.exports = __webpack_public_path__ + "static/img/more-4.91635d09.png";